import React from 'react';

/**
 * Reusable Tooltip Component
 * @param {React.ReactNode} children - The element to wrap with tooltip
 * @param {string} text - The tooltip text to display
 * @param {string} position - Position of tooltip: 'top', 'bottom', 'left', 'right' (default: 'bottom')
 */
export default function Tooltip({ children, text, position = 'bottom' }) {
  if (!text) return <>{children}</>;
  
  return (
    <>
      <style>{`
        /* Tooltip Wrapper */
        .tooltip-wrapper {
          position: relative;
          display: inline-flex;
          cursor: pointer;
        }

        /* Tooltip Text */
        .tooltip-wrapper::after {
          content: attr(data-tooltip);
          position: absolute;
          background-color: white;
          color: black;
          padding: 8px 12px;
          border-radius: 6px;
          font-size: 12px;
          white-space: nowrap;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
          border: 1px solid #a5dcf3;
          z-index: 1000;
          opacity: 0;
          visibility: hidden;
          transition: opacity 0.3s, visibility 0.3s;
          pointer-events: none;
        }

        /* Tooltip Arrow */
        .tooltip-wrapper::before {
          content: "";
          position: absolute;
          border: 5px solid transparent;
          z-index: 1000;
          opacity: 0;
          visibility: hidden;
          transition: opacity 0.3s, visibility 0.3s;
          pointer-events: none;
        }

        /* Show tooltip on hover */
        .tooltip-wrapper:hover::after,
        .tooltip-wrapper:hover::before {
          opacity: 1;
          visibility: visible;
        }

        /* Bottom position (default) */
        .tooltip-bottom::after {
          top: calc(100% + 5px);
          left: 50%;
          transform: translateX(-50%);
        }

        .tooltip-bottom::before {
          top: 100%;
          left: 50%;
          transform: translateX(-50%);
          border-bottom-color: white;
        }

        /* Top position */
        .tooltip-top::after {
          bottom: calc(100% + 5px);
          left: 50%;
          transform: translateX(-50%);
        }

        .tooltip-top::before {
          bottom: 100%;
          left: 50%;
          transform: translateX(-50%);
          border-top-color: white;
        }

        /* Left position */
        .tooltip-left::after {
          right: calc(100% + 5px);
          top: 50%;
          transform: translateY(-50%);
        }

        .tooltip-left::before {
          right: 100%;
          top: 50%;
          transform: translateY(-50%);
          border-left-color: white;
        }

        /* Right position */
        .tooltip-right::after {
          left: calc(100% + 5px);
          top: 50%;
          transform: translateY(-50%);
        }

        .tooltip-right::before {
          left: 100%;
          top: 50%;
          transform: translateY(-50%);
          border-right-color: white;
        }
      `}</style>
      
      <div className={`tooltip-wrapper tooltip-${position}`} data-tooltip={text}>
        {children}
      </div>
    </>
  );
}